import { useLocation, useSearchParams } from "react-router-dom";
import { useContent } from "../content/ContentContext";
import { SectionLabel } from "./Ui";
import { Reveal } from "./Reveal";
import EnquiryForm from "./EnquiryForm";
import EmailMeButton from "./EmailMeButton";
import { Linkedin } from "lucide-react";

const HIDDEN_ON = ["/owner"];

export default function ContactSection() {
  const { pathname } = useLocation();
  const [params] = useSearchParams();
  const preselect = params.get("service") || "";
  const { content } = useContent();
  const { site } = content;
  if (HIDDEN_ON.some((p) => pathname.startsWith(p))) return null;
  return (
    <section id="contact" data-testid="global-contact-section" className="no-print scroll-mt-24 border-t border-line bg-lavender/40">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-20">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-5">
            <Reveal>
              <SectionLabel>Contact</SectionLabel>
              <h2 className="mt-4 font-serif text-3xl font-semibold tracking-tight text-ink sm:text-4xl lg:text-5xl">
                Let&rsquo;s talk.
              </h2>
              <p className="mt-6 text-lg leading-relaxed text-muted">{site.contactIntro}</p>
            </Reveal>
            <Reveal delay={0.1} className="mt-10">
              <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-accent">Direct email</p>
              <a
                href={`mailto:${site.email}`}
                data-testid="contact-section-email-link"
                className="mt-3 block break-all font-serif text-lg font-medium text-plum hover:text-accent"
              >
                {site.email}
              </a>
              <EmailMeButton label="Email me directly" arrow="↗" testid="contact-section-email-me-button" className="mt-6" />
              <a
                href={site.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-linkedin-link"
                className="mt-5 -ml-3 inline-flex items-center gap-2 rounded-full px-3 py-1.5 font-semibold text-plum transition-colors duration-200 hover:bg-lavender/60 hover:underline focus:outline-none focus-visible:bg-lavender/60 focus-visible:ring-2 focus-visible:ring-accent underline-offset-4 text-sm"
              >
                <Linkedin aria-hidden="true" className="h-4 w-4" strokeWidth={2} />
                Connect with me on LinkedIn
                <span className="sr-only">(opens in a new tab)</span>
              </a>
            </Reveal>
          </div>
          <div className="lg:col-span-7">
            <Reveal delay={0.1}>
              <EnquiryForm idPrefix="gcf" preselect={preselect} />
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
